import React from "react";
import { ArrowRight } from "lucide-react";
import { AppButton, AppCardDescription, AppCardHeader, AppCardTitle } from "../../ui";

/**
 * RecordCardHead — the header every card on the student record shares: a
 * title, an optional one-line description, and whatever acts on the card on the
 * right.
 *
 * Local to the student record rather than in `ui/`: it is used by every tab of
 * one screen, which is the `ContextItem` precedent (ledger D7), not the
 * three-screens bar for the library.
 */
const RecordCardHead = ({ title, description, action }) => (
  <AppCardHeader className="tw-flex-row tw-items-start tw-justify-between tw-gap-3">
    <div className="tw-min-w-0">
      <AppCardTitle>{title}</AppCardTitle>
      {description && <AppCardDescription>{description}</AppCardDescription>}
    </div>
    {action && <div className="tw-flex tw-shrink-0 tw-flex-wrap tw-items-center tw-gap-2">{action}</div>}
  </AppCardHeader>
);

/**
 * The name of a table, for its toolbar. `AppDataTable` is its own card, so it
 * has no card header; this is what says which table it is, and how many rows.
 */
export const TableHeading = ({ title, count }) => (
  <div className="tw-flex tw-min-w-0 tw-items-baseline tw-gap-2">
    <h3 className="tw-m-0 tw-text-sm tw-font-semibold tw-text-content">{title}</h3>
    {count ? <span className="tw-text-[0.8125rem] tw-text-content-subtle">{count}</span> : null}
  </div>
);

/** "Attendance →" — a quiet link from a summary card to the tab with the full story. */
export const TabLink = ({ onClick, children }) => (
  <AppButton size="sm" variant="ghost" onClick={onClick}>
    {children} <ArrowRight size={16} />
  </AppButton>
);

export default RecordCardHead;
